import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

interface InviteLeadModalProps {
  open: boolean;
  email: string;
  onConfirm: () => void;
  onClose: () => void;
}

const InviteLeadModal: React.FC<InviteLeadModalProps> = ({
  open,
  email,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 700,
          borderBottom: "1px solid #eee",
          pb: 1,
        }}
      >
        Send Invitation
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Typography
          variant="body1"
          sx={{
            mb: 2,
            color: "text.secondary",
            fontWeight: 400,
            fontSize: "1.05rem",
            lineHeight: 1.5,
            letterSpacing: 0.2,
          }}
        >
          Are you sure you want to{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "primary.main" }}>
            send an invitation
          </Box>{" "}
          to:
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            backgroundColor: "primary.main",
            px: 2,
            py: 1,
            borderRadius: 2,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: 36,
              height: 36,
              flexShrink: 0,
            }}
          >
            <EmailOutlinedIcon sx={{ color: "#fff" }} />
          </Box>

          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: "#fff",
              wordBreak: "break-word",
            }}
          >
            {email}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="error"
          variant="outlined"
          startIcon={<CloseIcon />}
          sx={{ borderRadius: 2, fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          startIcon={<MailOutlineIcon />}
          variant="contained"
          sx={{ borderRadius: 2, fontWeight: 600 }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteLeadModal;
